import { render, staticRenderFns } from "./AllNews.vue?vue&type=template&id=38373a3e&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"
import style0 from "./AllNews.vue?vue&type=style&index=0&id=38373a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38373a3e",
  null
  
)

export default component.exports